import { InputAdornment, makeStyles, TextField } from '@material-ui/core';
import SearchIcon from '@mui/icons-material/Search';
import React, { useCallback } from 'react';

type SearchFieldProps = {
  placeholder?: string;
  searchText?: string;
  setSearchText: (text: string) => void;
  onChange?: (event: any) => void;
};

const makeSelectStyles = makeStyles(() => ({
  search: {
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #BCCAD4',
      boxShadow: '0 0 0 4px rgba(16, 24, 40, 0.05)'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '8px',
      borderColor: '#D7E0E6'
    }
  }
}));

export const SearchField: React.FC<SearchFieldProps> = ({ searchText, setSearchText, placeholder, onChange }) => {
  const patientSelectStyles = makeSelectStyles();

  const handleChange = useCallback(
    (event) => {
      setSearchText(event.target.value);
      onChange?.(event);
    },
    [onChange]
  );

  return (
    <TextField
      size="small"
      // Autofocus on textfield
      margin="normal"
      autoFocus
      placeholder={placeholder}
      fullWidth
      variant="outlined"
      className={patientSelectStyles.search}
      InputProps={{
        style: { fontSize: 14 },
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        )
      }}
      value={searchText}
      onChange={handleChange}
      onClick={handleChange}
      onKeyDown={(e) => {
        if (e.key !== 'Escape') {
          // Prevents autoselecting item while typing (default Select behaviour)
          e.stopPropagation();
        }
      }}
    />
  );
};
